import router from './router/index.js'
import store from './store'
import {
	Message
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
	getToken
} from '@/utils/auth' // get token from cookie

NProgress.configure({
	showSpinner: false
}) // NProgress Configuration

const whiteList = ['/login','/jhState', '/register','/findPaw','/resetPaw', '/home', '/about','/about/organization','/about/mainBusiness','/about/framework','/about/ourwish',
'/bsdm','/bsdm/bsdmIntro','/bsdm/applyScenario','/bsdm/worth','/bsdm/getBsdm','/standardService','/standardService/standardServe',
'/standardService/valueContribution','/standardService/publishedStandard','/newsCenter','/newsDetails','/newsCenter/news','/newsCenter/marketEvents',
'/joinUs','/joinUs/icaMember','/joinUs/memberNews','/joinUs/joinICA','/joinUs/memberList','/personalRegister','/unitRegister','/registerSuccess','/privacyPolicy','/cookiePolicy','/serviceTerms'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
	// start progress bar
	NProgress.start()
	// set page title
	next()
	// console.log(to.path,getToken())
	// determine whether the user has logged in
	const hasToken = getToken()
	if (hasToken) {
		if (to.path === '/login') {
			// if is logged in, redirect to the home page
			next('/admin')
			NProgress.done()
		} else {
			next()
		}
	} else {
		if (whiteList.indexOf(to.path) != -1) {
			next()
		} else {
			next(`/login`)
			NProgress.done()
		}
	}

})
router.afterEach(() => {
	// finish progress bar
	NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js